import { useOfferPageContext } from 'pages/offer/context';
import { formatNumber } from 'shared/lib';
import { CardVariant } from '../types';
import { Typography, TypographyType, TypographyColor } from './typography';
import { Spacing, SpacingSize, SpacingDirection } from './spacing';
import styles from './reward.module.scss';
import { Card } from '.';

/**
 * Reward(payment) block
 */
export const Reward = () => {
  const {
    userData: {
      salary,
      quarterlyBonus,
      annualBonus,
      allowance,
      salaryIncluding,
      pieceBonus,
      monthlyBonus,
      semiAnnualBonus,
    },
  } = useOfferPageContext();

  return (
    <Spacing size={SpacingSize.medium} direction={SpacingDirection.vertical} className={styles.reward}>
      <Typography type={TypographyType.h2}>Вознаграждение</Typography>

      <Spacing size={SpacingSize.small} direction={SpacingDirection.vertical} className={styles.rowSpacing}>
        <Card variant={CardVariant.salary} className={styles.salary}>
          <div>
            <Typography type={TypographyType.h6} color={TypographyColor.white}>
              ОКЛАД ДО ВЫЧЕТА НАЛОГОВ
            </Typography>
            <Typography type={TypographyType.h3} color={TypographyColor.white} className={styles.salaryText}>
              {formatNumber(salary)}
              <Typography type={TypographyType.h5} color={TypographyColor.white}>
                ₽
              </Typography>
            </Typography>
          </div>

          <Typography color={TypographyColor.textTertiary}>
            <div dangerouslySetInnerHTML={{ __html: salaryIncluding || '' }} />
          </Typography>
        </Card>

        <Spacing size={SpacingSize.small} direction={SpacingDirection.both} className={styles.bonuses}>
          <Card className={styles.bonus}>
            <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
              ГОДОВАЯ ПРЕМИЯ <sup>*</sup>
            </Typography>

            <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
              {annualBonus}
              <Typography type={TypographyType.h6}>
                от годового <br /> оклада
              </Typography>
            </Typography>
          </Card>

          {quarterlyBonus && (
            <Card className={styles.bonus}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                КВАРТАЛЬНАЯ ПРЕМИЯ <sup>**</sup>
              </Typography>

              <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
                {quarterlyBonus}
                <Typography type={TypographyType.h6}>
                  от квартального <br /> оклада
                </Typography>
              </Typography>
            </Card>
          )}

          {pieceBonus && (
            <Card className={styles.bonus}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                СДЕЛЬНАЯ ПРЕМИЯ <sup>**</sup>
              </Typography>

              <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
                {formatNumber(pieceBonus)} ₽
              </Typography>
            </Card>
          )}

          {monthlyBonus && (
            <Card className={styles.bonus}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                ЕЖЕМЕСЯЧНАЯ ПРЕМИЯ <sup>**</sup>
              </Typography>

              <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
                {monthlyBonus}
                <Typography type={TypographyType.h6}>
                  от месячного <br /> оклада
                </Typography>
              </Typography>
            </Card>
          )}

          {semiAnnualBonus && (
            <Card className={styles.bonus}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                ПОЛУГОДОВАЯ ПРЕМИЯ <sup>**</sup>
              </Typography>

              <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
                {semiAnnualBonus}
                <Typography type={TypographyType.h6}>
                  от полугодового <br /> оклада
                </Typography>
              </Typography>
            </Card>
          )}

          {allowance && (
            <Card className={styles.bonus}>
              <Typography type={TypographyType.h6} color={TypographyColor.titleTertiary}>
                НАДБАВКА
              </Typography>

              <Typography type={TypographyType.h3} color={TypographyColor.textHighlight} className={styles.bonusText}>
                {formatNumber(allowance)} ₽
              </Typography>
            </Card>
          )}
        </Spacing>

        <Typography type={TypographyType.medium} color={TypographyColor.textHint}>
          <sup>*</sup> Фактический размер премии зависит от&nbsp;времени, отработанного в&nbsp;отчётном периоде (нужно
          отработать не&nbsp;менее 3 месяцев в&nbsp;году) и&nbsp;выполнения KPI
        </Typography>
        <Typography type={TypographyType.medium} color={TypographyColor.textHint}>
          <sup>**</sup> Выплата премии предусмотрена для сотрудников, работающих в&nbsp;Х5&nbsp;Group на&nbsp;момент
          её&nbsp;начисления, выполнивших установленные KPI и&nbsp;имеющих необходимый стаж работы в&nbsp;компании,
          с&nbsp;учетом фактически отработанного времени, согласно Положению о&nbsp;премировании, установленного каждым
          активом Группы
        </Typography>
      </Spacing>
    </Spacing>
  );
};
